// extracted by mini-css-extract-plugin
export default {"search-results__item":"W9i2Nd"};